import React, { useContext, useState } from 'react';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import SoftwarePackageEditDialog from '@totem/components/software/edits/SoftwarePackageEditDialog';
import PackageContext from '@totem/components/software/software_package/packageContext';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import IBDIcon from '@totem/styles/Icon';
import { isNotNull, isNull } from '@totem/utilities/common';

const PackageEdit = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { data, onAction } = useContext(PackageContext);
  const [showEdit, setShowEdit] = useState<boolean>(false);

  const internalSystemAdministrator =
    permissions.internalSystemAdministrator.hasPermissions(userProfile);

  const handleCancelEdit = (refresh: boolean) => {
    setShowEdit(false);
    if (refresh) {
      onAction('refresh');
    }
  };

  if (!internalSystemAdministrator || isNull(data)) {
    return null;
  }

  return (
    <IBTooltip content={permissions.internalSystemAdministrator.tooltip}>
      <IBDIcon
        name="Edit"
        title="Edit Name / Publisher"
        onClick={() => setShowEdit(true)}
      />
      {internalSystemAdministrator && showEdit && isNotNull(data) && (
        <SoftwarePackageEditDialog
          visible={internalSystemAdministrator && showEdit && isNotNull(data)}
          onClose={handleCancelEdit}
          packageId={data.package.id}
          packageName={data.package.name}
          packagePublisher={data.package.publisher}
        />
      )}
    </IBTooltip>
  );
};

export default PackageEdit;
